var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.products,"headers":_vm.headers,"loading":_vm.loading},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('tr',[_c('td',{staticClass:"subtitle-2"},[_vm._v(_vm._s(item.sp_product_id))]),_c('td',[_c('product-view',{staticClass:"my-2",attrs:{"product":item}})],1),_c('td')])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }